import MicroModal from "micromodal";

const modal = () => {
  if (document.querySelector(".modal")) {
    MicroModal.init({
      disableScroll: true,
    });
  }
};

export default modal;
